import { Star } from "lucide-react";

const items = [
  "Opened for Rick Derringer",
  "Opened for Great White",
  "Opened for Badfinger",
  "Opened for ZZ Top",
  "Trapped in a Montana Winter — Out Now",
];

export const Marquee = () => {
  const loop = [...items, ...items, ...items];
  return (
    <div
      data-testid="tour-marquee"
      className="bg-[#B91C1C] border-y-2 border-black overflow-hidden py-4"
    >
      <div className="marquee-track">
        {loop.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-6 font-oswald uppercase tracking-[0.2em] text-white text-base md:text-xl"
          >
            <Star size={16} className="fill-white" strokeWidth={0} />
            <span>{t}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
